// Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 24597, offsets 1158:138599. Structure and names inferred from code, not screenshots.
import * as React from "react";
function Reveal({
  children: children,
  className: t = "",
  delay: i = 0,
  skipReveal: o = false,
}) {
  let a = (0, React.useRef)(null);
  return (
    (0, React.useEffect)(() => {
      let e = a.current;
      if (!e) return;
      if (o) {
        (e.classList.add("reveal-no-transition"),
          e.classList.add("visible"),
          requestAnimationFrame(() =>
            e.classList.remove("reveal-no-transition"),
          ));
        return;
      }
      let t = new IntersectionObserver(
        ([n]) => {
          n.isIntersecting &&
            (setTimeout(() => e.classList.add("visible"), 1e3 * i),
            t.unobserve(e));
        },
        {
          threshold: 0.1,
        },
      );
      return (
        t.observe(e),
        () => {
          t.disconnect();
        }
      );
    }, [i, o]),
    (
      <div ref={a} className={`reveal ${t}`}>
        {children}
      </div>
    )
  );
}
export { Reveal };
